export default {
  DARK: {
    heading: p => p.accentWhite,
    subtitle: p => p.accentWhite,
    paragraph: p => p.accentWhite,
    blockTitle: p => p.accentWhite,
    blockParagraph: p => p.accentWhite,
    price: p => p.primaryLight,
    link: p => p.primaryLight,
    background: p => p.tertiaryDark,
    backgroundColor: p => p.tertiaryDark
  },
  LIGHT: {
    heading: p => p.primaryDark,
    subtitle: p => p.tertiaryDark,
    paragraph: p => p.tertiaryDark,
    blockTitle: p => p.tertiaryDark,
    blockParagraph: p => p.tertiaryDark,
    price: p => p.primaryDark,
    link: p => p.primaryDark,
    background: p => p.tertiaryLight,
    backgroundColor: p => p.tertiaryLight
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    subtitle: p => p.tertiaryDark,
    paragraph: p => p.tertiaryDark,
    blockTitle: p => p.tertiaryDark,
    blockParagraph: p => p.tertiaryDark,
    price: p => p.primaryDark,
    link: p => p.primaryDark,
    background: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryExtraLight
  }
}
